/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorPersonalHealthRecordRegistrableTypename =
  "PharmacyCounselorPersonalHealthRecordRegistrable" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorPersonalHealthRecordRegistrable
 */
export interface PharmacyCounselorPersonalHealthRecordRegistrable {
  /**
   *
   * @type {boolean}
   * @memberof PharmacyCounselorPersonalHealthRecordRegistrable
   */
  permittedSharing?: boolean;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorPersonalHealthRecordRegistrable
   */
  readonly __typename?: string;
}

export function PharmacyCounselorPersonalHealthRecordRegistrableFromJSON(
  json: any
): PharmacyCounselorPersonalHealthRecordRegistrable {
  return PharmacyCounselorPersonalHealthRecordRegistrableFromJSONTyped(json, false);
}

export function PharmacyCounselorPersonalHealthRecordRegistrableFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorPersonalHealthRecordRegistrable {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorPersonalHealthRecordRegistrableTypename,

    permittedSharing: !exists(json, "permitted_sharing") ? undefined : json["permitted_sharing"],
  };
}

export function PharmacyCounselorPersonalHealthRecordRegistrableToJSON(
  object?: PharmacyCounselorPersonalHealthRecordRegistrable | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    permitted_sharing: value.permittedSharing,
  };
}
